import ApiService from '../ApiService';

const { REACT_APP_REST_ENDPOINT } = process.env;
const BASE = `${REACT_APP_REST_ENDPOINT}/statistiche-corsi-regione/rendicontazione-annuale`;

const StatisticheCorsiRegioneService = {
    /**
     * @param {{ anno_statistico: number, id_corso?: number, solo_corsi_asincroni?: boolean }} payload
     */
    getRendicontazioneAnno(payload) {
        return new Promise((resolve, reject) => {
            ApiService.postRequest(resolve, reject, BASE, payload);
        });
    },
};

export default StatisticheCorsiRegioneService;
